<section class="h5 d-flex flex-column flex-md-column flex-lg-row flex-xl-row gap-2">
    <strong class="mb-2">Step 3:</strong>
    <span class="fw-normal">Choose Your Produce Box</span>
</section>
<p class="text-muted mb-4">Join our community of subscribers who get fresh, local living made easy. Choose the box that
    fits your taste and lifestyle. Change it, skip it, or cancel anytime. Don't worry - you can change, remove, or skip
    your
    subscription whenever you want!</p>
<div class="row g-4 product-card-container">
    @if (isProduceBoxesLoading()) {
    <app-section-loader [message]="'Loading produce boxes...'" [loaderSize]="LoaderSizeEnum.LG"></app-section-loader>
    } @else {
    <div class="col-md-6">
        <h5 class="fw-semibold mb-3 text-center">Customizable Boxes</h5>
        <div class="d-flex flex-column gap-3">
            @for (box of customizable(); track box.id) {
            <ng-container *ngTemplateOutlet="boxTemplate; context: { box: box }"></ng-container>
            }

        </div>
    </div>
    <div class="col-md-6">
        <h5 class="fw-semibold mb-3 text-center">Non-Customizable Boxes</h5>
        <div class="d-flex flex-column gap-3">
            @for (box of nonCustomizable(); track box.id) {
            <ng-container *ngTemplateOutlet="boxTemplate; context: { box: box }"></ng-container>
            }

        </div>
    </div>
    }
</div>

<div class="mt-4 alert alert-light small fw-medium text-center mb-4 cursor-pointer d-flex align-items-center justify-content-center gap-2 text-black"
    (click)="onNext()">
    Not ready to commit? No problem. You’re still welcome to shop the market any time it’s open.
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
        class="d-none d-lg-block">
        <path
            d="M0.5 8.5C0.5 4.09375 4.0625 0.5 8.5 0.5C12.9062 0.5 16.5 4.09375 16.5 8.5C16.5 12.9375 12.9062 16.5 8.5 16.5C4.0625 16.5 0.5 12.9375 0.5 8.5ZM9.78125 12.5312L13.2812 9.03125C13.5625 8.75 13.5625 8.28125 13.2812 7.96875L9.78125 4.5C9.46875 4.1875 9 4.1875 8.71875 4.5C8.40625 4.78125 8.40625 5.25 8.71875 5.53125L10.9375 7.75H4.25C3.8125 7.75 3.5 8.09375 3.5 8.5C3.5 8.9375 3.8125 9.25 4.25 9.25L10.9375 9.28125L8.71875 11.5C8.40625 11.7812 8.40625 12.25 8.71875 12.5312C9 12.8438 9.46875 12.8438 9.78125 12.5312Z"
            fill="black" />
    </svg>

</div>

<ng-template #boxTemplate let-box="box">
    <div class="product-card" [class.active]="isActive(box.id)">
        <div class="d-flex flex-column">
            <div class="mb-2">
                <h6 class="product-card-title mb-1 fw-semibold">{{ box.name }}</h6>
                <div class="d-flex align-items-center gap-2 product-price-line">
                    <span class="product-price fw-semibold">
                        {{ box.bundle?.priceRange || box._signup.meta.priceRange }}
                    </span>
                    @if (box.bundle?.isPublished) {
                    <i class="fas fa-info-circle text-muted small"></i>
                    <a href="javascript:void(0)" class="small whats-link"
                        (click)="openModalWhatsInside($event, box)">What's Inside</a>
                    }
                </div>
            </div>
            <div class="img bg-light rounded mb-3 overflow-hidden position-relative">
                @defer (on immediate; prefetch on immediate) {
                <img [src]="box._signup.meta.image" alt="{{box.name}}"
                    class="w-100 h-100 object-fit-cover" />
                }
            </div>
            <div class="stats d-flex small text-muted gap-4 mb-3">
                <div class="d-flex align-items-center gap-1"><i class="fas fa-box-open"></i><span>{{
                        box._signup.meta.items }}</span></div>
                <div class="d-flex align-items-center gap-1"><i class="fas fa-user-friends"></i><span>{{
                        box._signup.meta.serves }}</span></div>
            </div>
            <div class="frequency-selector mb-3">
                <select class="form-select form-select-sm" [ngModel]="getSelectedFrequency(box.id)?.id || ''"
                    (ngModelChange)="onFrequencyChange(box.id, $event)" [disabled]="frequencies().length === 0">
                    @for (frequency of frequencies(); track frequency.id) {
                    <option [value]="frequency.id">{{ frequency.name }}</option>
                    }
                </select>
            </div>
            <button type="button" class="btn add-btn w-100 btn-secondary" (click)="toggle(box.id)" [class.added-btn]="isActive(box.id)">
                {{isActive(box.id)?'Added':'Add ' + box.name }}
            </button>
        </div>
    </div>
</ng-template>

<!-- Botón para continuar -->
<div class="d-flex justify-content-center mt-4">
    <button type="button" class="btn btn-primary px-4" [disabled]="!svc.canProceed('produce')" (click)="onNext()">
        Next <span class="ms-1">→</span>
    </button>
</div>